import { Controller } from "react-hook-form";
import { REQ_ERR_MSG } from "../../Shared/Helper/ValidationMessage";
import { IMaskInput } from "react-imask";

interface fSProps {
  name: string;
  control: any;
  placeholder?: string;
  className?: string;
  errors?: any;
  required?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  tabIndex?: number;
  defaultValue?: any;
  mask: any;
  lazy?: boolean;
  eager?: boolean;
  blocks?: any;
  value?: any;
  onAccept?: Function;
}

export default function MaskedInputField(props: fSProps) {
  const {
    control,
    placeholder,
    className,
    name,
    errors,
    required = false,
    tabIndex,
    defaultValue,
    mask,
    lazy,
    eager,
    blocks,
  } = props;

  let inputClassName = className || "";
  if (errors) {
    inputClassName += "border-danger";
  }

  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={{
          ...(required && { required: { value: true, message: REQ_ERR_MSG } }),
        }}
        render={({ field: { onChange, value } }) => (
          <IMaskInput
            tabIndex={tabIndex}
            mask={mask}
            eager={eager}
            lazy={lazy}
            blocks={blocks}
            onAccept={(value, mask) => {
              onChange(mask.typedValue);
            }}
            defaultValue={defaultValue}
            className={inputClassName}
            placeholder={placeholder}
          />
        )}
      />
      {errors && (
        <div>
          <span className="text-danger">{errors.message}</span>
        </div>
      )}
    </>
  );
}
